export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M10.25 13a.75.75 0 0 1 .75.75v5.969a.75.75 0 0 1-1.5 0v-4.161l-5.192 5.117a.75.75 0 0 1-1.053-1.069L8.437 14.5H4.234a.75.75 0 0 1 0-1.5h6.016Zm9.442-9.675a.75.75 0 0 1 1.053 1.069L15.563 9.5h4.203a.75.75 0 0 1 0 1.5H13.75a.75.75 0 0 1-.75-.75V4.281a.75.75 0 0 1 1.5 0v4.161l5.192-5.117Z"/>
</svg>
`;
